"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function escapeUri(uri) {
    var output = encodeURIComponent(uri);
    // AWS percent-encodes some extra non-standard characters in a URI
    output = output.replace(/[!'()*]/g, hexEncode);
    return output;
}
exports.escapeUri = escapeUri;
function hexEncode(c) {
    return "%" + c
        .charCodeAt(0)
        .toString(16)
        .toUpperCase();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjYXBlLXVyaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9lc2NhcGUtdXJpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsU0FBZ0IsU0FBUyxDQUFDLEdBQVc7SUFDbkMsSUFBSSxNQUFNLEdBQUcsa0JBQWtCLENBQUMsR0FBRyxDQUFDLENBQUM7SUFFckMsa0VBQWtFO0lBQ2xFLE1BQU0sR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDLFVBQVUsRUFBRSxTQUFTLENBQUMsQ0FBQztJQUUvQyxPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDO0FBUEQsOEJBT0M7QUFFRCxTQUFTLFNBQVMsQ0FBQyxDQUFTO0lBQzFCLE9BQU8sTUFBSSxDQUFDO1NBQ1QsVUFBVSxDQUFDLENBQUMsQ0FBQztTQUNiLFFBQVEsQ0FBQyxFQUFFLENBQUM7U0FDWixXQUFXLEVBQUksQ0FBQztBQUNyQixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGZ1bmN0aW9uIGVzY2FwZVVyaSh1cmk6IHN0cmluZyk6IHN0cmluZyB7XG4gIHZhciBvdXRwdXQgPSBlbmNvZGVVUklDb21wb25lbnQodXJpKTtcblxuICAvLyBBV1MgcGVyY2VudC1lbmNvZGVzIHNvbWUgZXh0cmEgbm9uLXN0YW5kYXJkIGNoYXJhY3RlcnMgaW4gYSBVUklcbiAgb3V0cHV0ID0gb3V0cHV0LnJlcGxhY2UoL1shJygpKl0vZywgaGV4RW5jb2RlKTtcblxuICByZXR1cm4gb3V0cHV0O1xufVxuXG5mdW5jdGlvbiBoZXhFbmNvZGUoYzogc3RyaW5nKSB7XG4gIHJldHVybiBgJSR7Y1xuICAgIC5jaGFyQ29kZUF0KDApXG4gICAgLnRvU3RyaW5nKDE2KVxuICAgIC50b1VwcGVyQ2FzZSgpfWA7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/util-uri-escape/build/escape-uri.js
// module id = AHy3
// module chunks = 0